<article class="ordertype" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <button class="accessibility-button" (click)="openAccessabiltyDialog()">
    <div class="icon">
      <svg viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 4C8.45 4 7.97917 3.80417 7.5875 3.4125C7.19583 3.02083 7 2.55 7 2C7 1.45 7.19583 0.979167 7.5875 0.5875C7.97917 0.195833 8.45 0 9 0C9.55 0 10.0208 0.195833 10.4125 0.5875C10.8042 0.979167 11 1.45 11 2C11 2.55 10.8042 3.02083 10.4125 3.4125C10.0208 3.80417 9.55 4 9 4ZM6 20V7C5 6.91667 3.98333 6.79167 2.95 6.625C1.91667 6.45833 0.933333 6.25 0 6L0.5 4C1.8 4.35 3.18333 4.60417 4.65 4.7625C6.11667 4.92083 7.56667 5 9 5C10.4333 5 11.8833 4.92083 13.35 4.7625C14.8167 4.60417 16.2 4.35 17.5 4L18 6C17.0667 6.25 16.0833 6.45833 15.05 6.625C14.0167 6.79167 13 6.91667 12 7V20H10V14H8V20H6Z" />
      </svg>
    </div>
    <span langkey="ordertype_accessibility_btn"></span>
  </button>
  <div class="logo">
    <span langkey="ordertype_title"></span><!--Willkommen im-->
    <img *ngIf="has_logo_image" [src]="logo_image_path" class="ya_image" />
  </div>
  <div class="container">
    <h1 langkey="ordertype_select"><!--Wie möchten Sie Ihre Bestellung?--></h1>
    <div class="ordertype-selector" [class.ordertype-selector--margin]="!allow_langauge_select">
      <a *ngIf="hasInHouseOption" (click)="chooseOrderTypeInHouse()" class="box inhouse">
        <div class="icon" inlineSVG="sot/sot-icon.svg#sot-in_house" [setSVGAttributes]="{class: 'order-icon'}"></div>
        <h2 langkey="ordertype_inhouse"><!--Hier essen--></h2>
      </a>

      <a *ngIf="hasPickupOption" (click)="chooseOrderTypePickup()" class="box takeaway">
        <div class="icon" inlineSVG="sot/sot-icon.svg#sot-pickup" [setSVGAttributes]="{class: 'order-icon'}"></div>
        <h2 langkey="ordertype_takeaway"><!--Mitnehmen--></h2>
      </a>
    </div>
  </div>

  <div *ngIf="allow_langauge_select" class="lang">
    <h3>{{languageText}}</h3>
    <div class="container">
      <ng-container *ngFor="let language of languages">
        <a (click)="chooseLanguage(language.key)" [class]="'btn lang' + (language.active ? ' active' : '')">
          <img *ngIf="language.key == 'de'" [src]="'./assets/core/sot/lang/de.jpg'" />
          <img *ngIf="language.key == 'en'" class="ya_image" [src]="language.image"
            error_src="./assets/core/sot/lang/en.jpg" />
          <img *ngIf="language.key != 'de' && language.key != 'en'" class="ya_image" [src]="language.image" />
        </a>
      </ng-container>
    </div>
  </div>
</article>